"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectShowPreviewTextOption_1 = require("../actions/selectShowPreviewTextOption");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var owa_session_store_1 = require("owa-session-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var MessagePreviewFull = /** @class */ (function (_super) {
    tslib_1.__extends(MessagePreviewFull, _super);
    function MessagePreviewFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onShowPreviewTextChange = function (ev, option) {
            selectShowPreviewTextOption_1.default(option.key === 'true');
        };
        return _this;
    }
    MessagePreviewFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var showPreviewText = owa_options_core_1.getFallbackValueIfNull(optionStore.showPreviewTextInListView, userOptions.ShowPreviewTextInListView);
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + showPreviewText, options: [
                {
                    key: 'true',
                    text: owa_options_strings_1.default.options_messageList_previewShow,
                },
                {
                    key: 'false',
                    text: owa_options_strings_1.default.options_messageList_previewHide,
                },
            ], onChange: this.onShowPreviewTextChange, label: owa_options_strings_1.default.options_messageList_previewLabel }));
    };
    MessagePreviewFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], MessagePreviewFull);
    return MessagePreviewFull;
}(React.Component));
exports.default = MessagePreviewFull;
//# sourceMappingURL=MessagePreviewFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-preview-option/lib/components/MessagePreviewFull.js
// module id = 5107
// module chunks = 2